module.exports = __webpack_public_path__ + "img/index06.1740103c.jpg";